import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Person4Icon from '@mui/icons-material/Person4';
import PathalogyFilter from './pathalogyFilter';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import Box from '@mui/material/Box';
import Fab from '@mui/material/Fab';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import Badge from '@mui/material/Badge';
import Stack from '@mui/material/Stack';
import SideDrawer from './pathalogyCartDetails';
import { useLocation, useNavigate } from 'react-router-dom';
import AccountCircle from '@mui/icons-material/AccountCircle';
import { errorToast, successToast } from '../../components/toastmessage/toastmessage';
import PatinetInfo from '../../components/PatientInfo/patientInfo';
import PathalogyTable from './pathologyTable';
import { removeDuplicates } from '../../utils/helper';


const initialState = {
    ReferredBy: ""
}
const Pathalogy = () => {
    let location = useLocation();
    const [count, setCount] = useState(0)
    const [open, setOpen] = useState(false)
    const [pathlogyList, setPathlogyList] = useState([]);
    const [pathalogyCartItems, setPatCartItems] = useState([])
    const [PatientInfo, setPatientInfo] = useState([]);
    const getUserValue = JSON.parse(sessionStorage.getItem("loginDetails"))
    const [referredByInputFields, setReferredByInputFields] = useState(initialState);
   

  
    const fetchLabtest = () => {
        axios.get("https://arogyanxtdevapi.fundaclear.in/api/Lab/labTests")
            .then((res) => {
                const { data: { result }, status } = res;
                if (status === 200) {
                    const uniqueArray = removeDuplicates(result, 'testName');
                    setPathlogyList(uniqueArray)
                }

            }).catch(err => err)
    }
    useEffect(() => {
        fetchLabtest();

    }, []);
    const handleAddCart = (params) => {
        setCount((prevState) => prevState + 1)
        setPatCartItems((prevState) => [...prevState, { price: params?.price, testID: params?.testID, testName: params?.testName }])
    }

    const actionColumn = [
        {
            field: "action",
            headerName: "Action",
            width: 200,
            renderCell: (params) => {
                return (
                    <div className="cellAction">
                        <div className="viewButton"
                            onClick={() => handleAddCart(params.row)}
                        >Add To Cart</div>
                    </div>
                );
            },
        },
    ];
    const handleGetRowId = (e) => {
        return e?.testID
    }
    const handleDrawerOpen = (event) => {
        event?.preventDefault();
        setOpen(true)
        axios.get(`https://arogyanxtdevapi.fundaclear.in/api/v1/Patient/${location?.state?.rowData?.uniqueID}`)
            .then((res) => {
                if (res?.status === 200) {
                    setPatientInfo(res?.data?.result)
                }

            }).catch(err => err)
    }
    const handleCloseDrawer = () => {
        setOpen(false)
        setPatCartItems([]);
        setCount(0)
        setReferredByInputFields({})
    }

    const caluculateTotal = (totalAmount) => {
        let amount = totalAmount && totalAmount?.length > 0 && totalAmount?.reduce(function (accumulator, cur) {
            return accumulator + cur?.price;
        }, 0);
        return amount;
    }
    const handaleSubmit = (event) => {
        event?.preventDefault();
        const body = {
            tenantId: getUserValue?.tenantID,
            totAmount: caluculateTotal(pathalogyCartItems),
            createdBy: getUserValue?.uniqueID,
            patientId: location?.state?.rowData?.uniqueID,
            referredBy: referredByInputFields?.ReferredBy,
            tests: pathalogyCartItems,
        }
        // https://labnxt.fundaclear.in/api/patient/LabRequest
        axios.post(`https://arogyanxtdevapi.fundaclear.in/api/Lab/labRequest`, body).then((res) => {
            if (res?.status === 200) {
                successToast(res?.data?.message || res?.data?.Message);
                setOpen(false)
                setPatCartItems([]);
                setCount(0)
            }
        }).catch(err => errorToast(err?.response?.data?.error || err?.response?.data?.Message))

    }
    const handleClose = (event) => {
        event.preventDefault();
        setOpen(false)
        setPatCartItems([]);
        setCount(0)
        setReferredByInputFields({})
    }
    const handleRemove = (event, item) => {
        event?.preventDefault()
        const deleteArray = [...pathalogyCartItems];
        const index = deleteArray.indexOf(item);
        deleteArray.splice(index, 1);
        setPatCartItems(deleteArray)
    }

    const handleFilterClick = (event, filterInputs) =>{
        event.preventDefault();
        if (!pathlogyList || !Array.isArray(pathlogyList) || !filterInputs || typeof filterInputs !== 'object') {
            errorToast('Invalid data or filterInputs provided');
          return [];
        }
      
        let filterData =  pathlogyList.filter((item) =>
          Object.entries(filterInputs).every(([key, value]) =>
            item[key] && item[key].toString().toLowerCase().includes(value.toString().toLowerCase())
          )
        );
        setPathlogyList(filterData);
        
      }
  




    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setReferredByInputFields((prevState) => {
            return {
                ...prevState,
                [name]: value,
            };
        });

    }
    const testDetails = (
        <div className="cart-details">
            <div className="form-group">
                <label for="validationCustom03" className="control-label">Referred By*</label>
                <div className="referedby">
                    <div class="input-group">
                        <div className="input-group-prepend">
                            <div className="input-group-text"><AccountCircle /></div>
                        </div>
                        <input type="text"
                            className="form-control"
                            id="validationCustom03"
                            required
                            aria-describedby="emailHelp"
                            placeholder="Referred By"
                            name="ReferredBy"
                            value={referredByInputFields?.ReferredBy}
                            onChange={handleInputChange}
                        />
                        <div class="invalid-feedback">
                            Please provide a valid Name.
                        </div>
                    </div>
                </div>
            </div>
            {
                pathalogyCartItems && pathalogyCartItems?.length > 0 ? pathalogyCartItems?.map((item, index) => {
                    return (
                        <div className="pathaology-cart-details">
                            <div className='d-flex justify-content-between align-items-center py-1'>
                                <Person4Icon style={{ color: "rgb(56, 151, 157)" }} />
                                <p style={{
                                    fontWeight: 600, color: "rgb(139, 139, 139)"
                                }}>{item?.testName}</p>

                                <div className='d-flex justify-content-between align-items-center py-1'>
                                    <RemoveCircleOutlineIcon onClick={(e) => handleRemove(e, item)} />
                                </div>
                            </div>
                            <div className='d-flex justify-content-between align-items-center py-1' style={{ borderBottom: "1px solid rgba(221, 221, 221, 0.867)" }}>
                                <label style={{ fontSize: 20, marginLeft: 10, color: "rgb(56, 151, 157)", fontWeight: 600 }}>₹</label>
                                <p style={{ fontWeight: 600, color: "rgb(139, 139, 139)" }}>₹{item?.price}</p>
                                <div className='d-flex justify-content-between align-items-center py-1'>

                                </div>
                            </div>
                        </div>
                    )
                }) : null
            }
            <div className="total d-flex justify-content-between align-items-center p-2">
                <label style={{
                    fontSize: 25,
                    fontWeight: 600,
                    color: "rgb(126, 126, 126)"
                }}>Total:</label>
                <p style={{ fontWeight: 600, color: "rgb(139, 139, 139)", fontSize: "25px" }} className="">₹{caluculateTotal(pathalogyCartItems)}</p>
            </div>
            <div className="drawer-button-margin">
                <div className="container">
                    <div className="row pt-3">
                        <div className="col-6 pl-2">
                            <button
                                data-test="cancel"
                                id="signupSubmit2"
                                type="submit"
                                className="btn drawer-button-info btn-block"
                                onClick={handleClose}
                            >
                                cancel
                            </button>
                        </div>
                        <div className="col-6 pr-2">
                            <button
                                data-test="submit"
                                id="signupSubmit"
                                type="submit"
                                className="btn drawer-create-button btn-block"
                                onClick={handaleSubmit}
                                disabled={
                                    referredByInputFields && referredByInputFields?.ReferredBy?.length > 0 ? false : true
                                }
                            >
                                Submit
                            </button>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )

   
    return (
        <>
            <PatinetInfo rowData={location} />
            <div className="pathalogy">
                <div className="d-flex justify-content-between mt-3">
                    <div className="mt-2 ml-4">
                        <h4>Pathalogy</h4>
                    </div>
                    <div className='d-flex'>
                        <div className='d-flex justify-content-end'>
                            <Box sx={{ '& > :not(style)': { mr: 2 } }} onClick={handleDrawerOpen}>
                                <Stack spacing={2} direction="row">
                                    <Badge badgeContent={count} color="primary">
                                        <Fab color="secondary" aria-label="add">
                                            <ShoppingCartIcon />
                                        </Fab>
                                    </Badge>
                                </Stack>
                            </Box>

                        </div>
                        <div className='pathalogy-filter'>
                            <PathalogyFilter
                                handleFilterClick={handleFilterClick} f
                                fetchLabtest={fetchLabtest} />
                        </div>
                    </div>
                </div>
                <div className="datatable">
                    <PathalogyTable pathlogyList={pathlogyList} 
                    handleGetRowId={handleGetRowId} 
                    actionColumn={actionColumn} />
                </div>

            </div>
                {open &&
                    <SideDrawer
                        content={testDetails}
                        open={open}
                        handleDrawerClose={handleCloseDrawer}
                        drwawerHeader={"Test Details"}
                        drawerWidthSize={500}
                    />
                }
        </>
    )
}

export default Pathalogy;